module.exports = __webpack_public_path__ + "img/xinwen4.9d61ad47.jpg";